import { HelmetProvider, Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

interface PageMetaProps {
  title: string;
  description: string;
}

const PageMeta: React.FC<PageMetaProps> = ({ title, description }) => {
  const { t } = useTranslation(); // preparado para traducciones si se necesita

  return (
    <Helmet>
      <title>{t(title)}</title>
      <meta name="description" content={t(description)} />
    </Helmet>
  );
};

interface AppWrapperProps {
  children: React.ReactNode;
}

export const AppWrapper: React.FC<AppWrapperProps> = ({ children }) => (
  <HelmetProvider>{children}</HelmetProvider>
);

export default PageMeta;
